// import { DragSourceMonitor, DropTargetMonitor, useDrag, useDrop, XYCoord } from 'react-dnd'
import { Checkbox, Spinner } from "@blueprintjs/core";
import { IDataTableColumn, IUseGridStateReturn } from "nsitools-react";
import * as React from "react";

import styled from "styled-components";

export interface ISelectKeyColumnProps<T> {
  onToggleSelectAll?: () => Promise<Set<any>> | Set<any>;
  tableState: IUseGridStateReturn<T>;
}

const StyledCheckbox = styled(Checkbox)`
  margin-bottom: 0px !important;
  margin-right: -11px !important;
`;

export function SelectKeyColumn<T>({
  onToggleSelectAll,
  tableState,
}: ISelectKeyColumnProps<T>) {
  const [onToggleSelectAllLoading, setOnToggleSelectAllLoading] =
    React.useState(false);

  const allKeysSelected = React.useMemo(
    () => tableState?.allKeysSelected,
    [tableState?.allKeysSelected]
  );

  return {
    fieldName: "__selectionKey",
    header: () =>
      onToggleSelectAll &&
      (onToggleSelectAllLoading ? (
        <Spinner size={15} />
      ) : (
        <StyledCheckbox
          disabled={onToggleSelectAllLoading}
          checked={allKeysSelected}
          onChange={async () => {
            if (allKeysSelected) {
              tableState?.clearSelectedKeys();
            } else {
              setOnToggleSelectAllLoading(true);
              const allKeys = await onToggleSelectAll();
              tableState?.setSelectedKeys(allKeys);
              setOnToggleSelectAllLoading(false);
            }
          }}
        />
      )),
    render: (item: T) => (
      <StyledCheckbox
        checked={tableState?.selectedKeys.has(
          tableState?.keyFieldAccessor(item)
        )}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          e.stopPropagation();
          tableState?.toggleSelectedKey(tableState?.keyFieldAccessor(item));
        }}
      />
    ),
    autoFitContent: true,
    disableSorting: true,
    disableCustomization: true,
    headerAlignment: "center",
    alignment: "center",
  } as IDataTableColumn<any>;
}
